import React, { useEffect, useState } from 'react';
import { Card, Table, Tag,Space, Progress, Collapse, Spin, message, Typography, Divider } from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import RefreshDataButton from '../SetupComponent/RefreshDataButton';

const { Panel } = Collapse;
const { Text } = Typography;

const ClonedOrgLogs = ({ clonedOrg }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [overallProgress, setOverallProgress] = useState(null);
  const [overallStatus, setOverallStatus] = useState('');
  const [overallErrors, setOverallErrors] = useState([]);

  const fetchCloneLogs = async () => {
    if (!clonedOrg) return;
    try {
      setLoading(true);
      const apiService = new ApiService(
        `${BASE_URL}/super_admin/clone_status/${clonedOrg}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );

      const response = await apiService.makeCall();
      console.log('Clone logs response:', response);

      if (!response || !response.task) {
        message.error('Invalid or empty response');
        return;
      }

      const {
        mappings = {},
        progress = {},
        status = '',
        clone_errors = [],
      } = response.task;

      const itemsProgress = progress.items || {};

      // Transform progress info into table data
      const formattedLogs = Object.entries(itemsProgress).map(([type, info]) => {
        const total = info.total || 0;
        const completed = info.completed || 0;
        const percent = total ? Math.round((completed / total) * 100) : 0;

        return {
          type,
          total,
          success: completed,
          percent,
        };
      });

      setLogs(formattedLogs);
      setOverallProgress(progress);
      setOverallStatus(status);
      setOverallErrors(clone_errors);
    } catch (err) {
      console.error('Error fetching clone logs:', err);
      message.error('Failed to fetch clone logs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCloneLogs();
  }, [clonedOrg]);

  const columns = [
    {
      title: 'Metadata Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Progress',
      key: 'progress',
      render: (_, record) => (
        <Progress percent={record.percent} status="active" size="small" />
      ),
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Completed',
      dataIndex: 'success',
      key: 'success',
      render: (val) => <Tag color="green">{val}</Tag>,
    },
  ];

  const statusColor =
    overallStatus === 'completed'
      ? 'green'
      : overallStatus === 'in_progress'
      ? 'blue'
      : 'red';

  return (
    <Card
      title={<Text strong>Clone Progress Logs</Text>}
      extra={<RefreshDataButton onClick={fetchCloneLogs} loading={loading} />}
      size="small"
      bordered
    >

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          {overallProgress && (
            <>
              <div style={{ marginBottom: 16 }}>
                <Text strong>Status: </Text>
                <Tag color={statusColor}>{overallStatus.toUpperCase()}</Tag>
                <Text style={{ marginLeft: 8 }}>
                  Stage: {overallProgress.stage || '-'}
                </Text>
              </div>

              <Progress
                percent={overallProgress.percent || 0}
                status={overallStatus === 'failed' ? 'exception' : 'active'}
                style={{ marginBottom: 12 }}
              />

              {overallErrors.length > 0 && (
                <Collapse ghost>
                  <Panel
                    header={`Global Errors (${overallErrors.length})`}
                    key="global-errors"
                  >
                    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {overallErrors.map((err, idx) => (
                          <li key={idx} style={{ color: 'red', marginBottom: 6 }}>
                            {err}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Panel>
                </Collapse>
              )}

              <Divider />
            </>
          )}

          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            <Table
              dataSource={logs}
              columns={columns}
              rowKey="type"
              pagination={false}
              size="middle"
              bordered
            />
          </div>
        </>
      )}
    </Card>
  );
};

export default ClonedOrgLogs;
